import * as React from "react"
import { connect } from "react-redux"
import { bindActionCreators, Dispatch } from "redux"
import LocalAuthorityListComponent from "./local-authority-list-component"
import { LocalAuthority, Instruction } from "../../../model"
import * as actionCreators from "../../../action-creators"
import { Profile } from "../../../domain/sfp/user-domain"
import { ReducerState, MappedActionsProps } from "../../../reducer"
import { RouteComponentProps } from "react-router"
import { findInstructions } from "../../../service/sfp/instructions-service-2"
import { NotificationLevel } from "../../notification"

class LocalAuthorityList extends React.Component<InjectedProps, State> {
	protected editingProfiles: Profile[] = [
		Profile.SuperAdmin,
		Profile.RegionAdmin,
		Profile.LocalAuthorityAdmin
	]
	protected viewProfiles: Profile[] = [
		Profile.LocalAuthorityConsultant
	]
	private abortController: AbortController = new AbortController

	constructor(props: InjectedProps) {
			super(props)
			this.state = {
				addLocalAuthority: false,
				addChildLocalAuthority: false,
				instructions: [],
				instructionsLoaded: false,
				loadingInstructions: false,
				loadingLocalAuthorities: [],
				localAuthorities: [],
				localAuthority: null,
				resourcesLoaded: false,
				viewLocalAuthority: false,
				editExtraLocalAuthority: false,
				selectedSlug: "",
				selectedFile: null,
				isLoadingFile: false,
				isLoadingFileValidation: false,
				errorUpload: false,
				messageUpload: '',
				messageValidation: null,
			}
		}

		componentDidMount() {
			this.props.actions.setPageTitle("Collectivités")
			this.initState(this.props)
			this.props.currentLocalAuthority
		}

		componentDidUpdate() {
			this.initState(this.props)
		}

		componentWillUnmount() {
			this.abortController.abort()
		}

		render() {
			const loading = this.props.loadingLocalAuthorities
				|| this.props.loadingCurrentUser

			return <LocalAuthorityListComponent
				selectedSlug={this.state.selectedSlug}
				addLocalAuthority={this.state.addLocalAuthority}
				addChildLocalAuthority={this.state.addChildLocalAuthority}
				currentUser={this.props.currentUser}
				editingLocalAuthorities={this.state.loadingLocalAuthorities}
				viewingLocalAuthoritiesChildren={this.props.loadingLocalAuthoritiesChildren}
				editingProfiles={this.editingProfiles}
				loading={loading}
				currentLocalAuthority={this.props.currentLocalAuthority}
				loadingInstructions={this.state.loadingInstructions}
				instructions={this.state.instructions}
				localAuthorities={this.props.localAuthorities}
				localAuthoritiesChildren={this.props.localAuthoritiesChildren}
				localAuthority={this.state.localAuthority}
				viewLocalAuthority={this.state.viewLocalAuthority}
				editExtraLocalAuthority={this.state.editExtraLocalAuthority}
				viewProfiles={this.viewProfiles}
				onClickAddLocalAuthority={() => this.handleClickAddLocalAuthority()}
				onClickViewLocalAuthorityChild={(l) => this.handleClickViewChildLocalAuthority(l)}
				onClickAddChildLocalAuthority={(l) => this.handleClickAddChildLocalAuthority(l)}
				onClickViewLocalChildAuthority={(l) => this.handleClickViewLocalChildAuthority(l)}
				onClickDeleteLocalAuthorityChild={(l) => this.handleClickDeleteLocalChildAuthority(l)}
				onClickEditChildLocalAuthority={(l) => this.handleClickEditExtraChildLocalAuthority(l)}
				onCloseViewLocalChildAuthority={() => this.handleCloseViewLocalChildAuthority()}
				onCloseAddChildLocalAuthority={() => this.handleCloseAddChildLocalAuthority()}
				onLocalChildAuthorityCreated={(l) => this.handleLocalChildAuthorityCreated(l)}
				onLocalExtraChildAuthorityCreated={() => this.handleLocalExtraChildAuthorityCreated()}
				onClickViewLocalAuthority={l => this.handleClickViewLocalAuthority(l)}
				onCloseAddLocalAuthority={() => this.handleCloseAddLocalAuthority()}
				onCloseEditLocalAuthority={() => this.handleCloseViewLocalAuthority()}
				onCloseEditExtraChildLocalAuthority={() => this.handleCloseExtraChildViewLocalAuthority()}
				onLocalAuthorityCreated={() => this.handleLocalAuthorityCreated()}
				onLocalAuthorityUpdated={() => this.handleLocalAuthorityUpdated()}
				onLocalAuthorityExtraChidEdited={(l) => this.handleExtraChildEditedLocalAuthorityUpdated(l)}
				onLocalAuthorityUpdatedPA={(l)=>this.handleOnSameLocalAthority(l)}
				handleFile={e => this.onFileChange(e)}
				uploadFile={(l, v) => this.onUploadFile(l, v)}
				isLoadingFile={this.state.isLoadingFile}
				isLoadingFileValidation={this.state.isLoadingFileValidation}
				errorUpload={this.state.errorUpload}
				messageUpload={this.state.messageUpload}
				messageValidation={this.state.messageValidation}
			/>

		}

		private onUploadFile = async (localAuthority: LocalAuthority, validation = false) => {
			const formData = this.state.selectedFile
			this.setState({ messageUpload: "", messageValidation: null });
			try {
				if (validation) {
					this.setState({ isLoadingFileValidation: true });
					const result = await this.props.actions.uploadFileXmlValidation(localAuthority.id, formData);		
					this.setState({ 
						messageValidation: result['message'],
						errorUpload: false,
					});
				} else {
					this.setState({ isLoadingFile: true });
					await this.props.actions.uploadFileXml(localAuthority.id, formData);			
					this.setState({ 
						messageUpload: "Données mise à jour avec succès.",
						errorUpload: false ,
					});
					this.props.actions.fetchLocalAuthorities();		
				}
			} catch (error) {
				this.setState({ 
					messageUpload: error.message || "Une erreur est survenue lors du téléchargement.", 
					errorUpload: true 
				});
			} finally {
				this.setState({ isLoadingFile: false });
				this.setState({ isLoadingFileValidation: false });
			}
		}
	
		private onFileChange = event => {
			this.setState({ selectedFile: event.target.files[0], messageUpload: "" })
		};
	

		private handleClickAddLocalAuthority(): void {
			this.setState({ addLocalAuthority: true })
		}

		private handleClickViewLocalAuthority(localAuthority: LocalAuthority): void {
			this.setState({ viewLocalAuthority: true, localAuthority })
		}

		// For Edit Extra Child
		private handleClickEditExtraChildLocalAuthority(localAuthority: LocalAuthority): void{
			this.setState({ editExtraLocalAuthority: true,localAuthority})
		}

		// For updating PA if LA is same
		private handleOnSameLocalAthority(l) {
			this.props.actions.fetchCurrentLocalAuthorityIfCollectivitiesPage(l.id)
		}
		
		private handleCloseAddLocalAuthority(): void {
			this.setState({ addLocalAuthority: false })
		}

		private handleCloseViewLocalAuthority(): void {
			this.setState({ viewLocalAuthority: false, localAuthority: null })
		}

        // For Edit Extra Child Close
		private handleCloseExtraChildViewLocalAuthority(): void {
			this.setState({ editExtraLocalAuthority: false, localAuthority: null })
		}

		private handleLocalAuthorityCreated() {
			this.props.actions.fetchLocalAuthorities()
			this.setState({ addLocalAuthority: false })
		}

		private handleLocalAuthorityUpdated() {
			this.props.actions.fetchLocalAuthorities()
			this.setState({ viewLocalAuthority: false })
		}

		// Making Call For Edit Extra Child
		private handleExtraChildEditedLocalAuthorityUpdated(localAuthority) {
			this.props.actions.fetchLocalAuthoritiesChildren(localAuthority.parentSlug)
			this.setState({ editExtraLocalAuthority: false, localAuthority: null })
		}
	

		// Add child into local authority
		private handleClickAddChildLocalAuthority(localAuthority: LocalAuthority): void {
			this.setState({ addChildLocalAuthority: true, localAuthority })
		}
		private handleClickViewChildLocalAuthority(localAuthority: LocalAuthority): void {
			this.props.actions.fetchCurrentLocalAuthorityIfNeeded(localAuthority.slug)
			this.props.history.push({pathname:`/${localAuthority.slug}`,state:{ la:localAuthority }})
		}

		


		private handleCloseAddChildLocalAuthority(): void {
			this.setState({ addChildLocalAuthority: false, localAuthority: null })
		}


		private handleLocalChildAuthorityCreated(localAuthority) {
			this.props.actions.fetchLocalAuthoritiesChildren(localAuthority.slug)
			this.setState({ addChildLocalAuthority: false })
		}

		// for Creating Extra Child into local authority
		private handleLocalExtraChildAuthorityCreated() {
			this.setState({ addChildLocalAuthority: false })
		}
		

		private handleClickViewLocalChildAuthority(localAuthority) {
			if (!localAuthority.slug || this.props.loadingLocalAuthoritiesChildren) return
			this.setState({ selectedSlug: localAuthority.slug })
			this.props.actions.fetchLocalAuthoritiesChildren(localAuthority.slug)
		}

		private handleClickDeleteLocalChildAuthority(localAuthority) {
			if (!localAuthority.slug || this.props.loadingLocalAuthoritiesChildren) return
			if (confirm("You want to Delete!")) {
				this.props.actions.fetchLocalAuthoritiesDeleteChildren(localAuthority)
			  } else {
			  }
			
		}


		private handleCloseViewLocalChildAuthority() {
			this.props.actions.clearLocalAuthoritiesChildren()
			this.setState({ selectedSlug: "" })
		}

		private initState(props: InjectedProps): void {
			if (this.state.loadingInstructions) return
			if (this.state.instructionsLoaded) return

			this.setState({ loadingInstructions: true }, () => {
				findInstructions(this.abortController.signal)
				.then(instructions => {
					this.setState({
						instructions,
						instructionsLoaded: true,
						loadingInstructions: false
					})
				})
				.catch(reason => {
					this.setState({
						instructionsLoaded: true,
						loadingInstructions: false
					}, () => {
						this.props.actions.notify(
							NotificationLevel.Danger,
							"Impossible de charger les instructions",
							reason
						)
					})
				})
			})
		}
}

export default connect(mapStateToProps, mapDispatchToProps)(LocalAuthorityList)

function mapDispatchToProps(dispatch: Dispatch<ReducerState>): MappedActionsProps {
	return { actions: bindActionCreators(actionCreators, dispatch) }
}

function mapStateToProps(state: ReducerState): ReducerState {
	return state
}

interface Params {}

interface State {
	addLocalAuthority: boolean
	addChildLocalAuthority: boolean
	instructions: Instruction[]
	instructionsLoaded: boolean
	loadingInstructions: boolean
	loadingLocalAuthorities: LocalAuthority[]
	localAuthorities: LocalAuthority[]
	localAuthority: LocalAuthority
	resourcesLoaded: boolean
	viewLocalAuthority: boolean
	editExtraLocalAuthority:boolean
	selectedSlug: string
	selectedFile: any
	isLoadingFile: boolean,
	isLoadingFileValidation: boolean,
	errorUpload: boolean,
	messageUpload: string
	messageValidation: string[] | null
}

type InjectedProps = ReducerState & MappedActionsProps & RouteComponentProps<Params>



// WEBPACK FOOTER //
// ./src/component/page/local-authority-list-page/index.tsx